import React, { useState } from "react";


interface FaqItem {
    question: string;
    answer: string;
}

const faqs: FaqItem[] = [
    {
        question: "What type of software solutions do you offer?",
        answer: "Our company specializes in a wide range of software solutions, including but not limited to mobile applications, web development, enterprise software, AI-driven solutions, IoT integrations, and more. We cater to diverse industries and customize our solutions based on specific client needs."
    },
    {
        question: "Can you provide examples of your previous work or client success stories?",
        answer:
            "Absolutely! We have a rich portfolio showcasing our successful projects across various industries. These case studies highlight our expertise, innovative solutions, and the positive impact we’ve made for our clients. We’d be delighted to share these examples to demonstrate our capabilities.",
    },
    {
        question: "What is your approach to customer support and service?",
        answer:
            "Our commitment to customer support is unwavering. We offer comprehensive support throughout the project lifecycle and beyond. Our dedicated support teams are available 24/7 to address queries, provide technical assistance, and ensure a smooth and seamless experience for our clients.",
    },
    {
        question: "How do you ensure user-friendly and intuitive software design?",
        answer:
            "User experience is a top priority for us. Our design and development processes are centered around user-centric principles. We conduct thorough user research, employ intuitive interface design, and iterate based on user feedback to create software that is both functional and easy to use.",
    },
    {
        question: "What services do you offer for website development?",
        answer:
            "We specialize in various website services, including design, development, optimization, e-commerce solutions, content management systems (CMS), responsive design for mobile devices, and website maintenance.",
    },
    {
        question: "Can you help with website redesign or updates to an existing site?",
        answer:
            "Absolutely! We offer redesign services to enhance existing websites, whether it’s a complete overhaul or updates to improve functionality, design, or content. Our goal is to modernize and optimize your website to meet current standards.",
    },
    {
        question: "How do you ensure my website is mobile-friendly and responsive?",
        answer: "All our websites are built with responsive design, ensuring compatibility across various devices and screen sizes. We prioritize user experience, ensuring that your site looks and functions optimally on desktops, tablets, and smartphones."
    },
    {
        question: "Can you integrate e-commerce functionality into a website?",
        answer: "Absolutely! We specialize in e-commerce solutions, offering integration of secure payment gateways, inventory management systems, shopping carts, and user-friendly interfaces for seamless online transactions."
    }
];

const FaqSection: React.FC = () => {
    const [openIndex, setOpenIndex] = useState<number>(0); // Default open first

    const handleToggle = (index: number) => {
        setOpenIndex(prev => (prev === index ? -1 : index));
    };

    return (
        <section className="py-20 px-4 bg-white max-w-6xl mx-auto">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
                {/* Left Column */}
                <div>
                    {/* Badge */}
                    <span className="inline-block text-xs bg-[#e0f8de] text-green-700 font-semibold px-4 py-1 rounded-full mb-4">
                        FAQ
                    </span>

                    {/* Heading */}
                    <h2 className="text-3xl md:text-4xl font-bold text-[#0A033C] mb-5">
                        Frequently&nbsp; Asked Questions
                    </h2>

                    {/* Subheading */}
                    <p className="text-gray-500 mb-10">
                        Find answers to your questions about Minterminds
                    </p>

                    {/* Support Cards */}
                    <div className="space-y-6 pe-24">
                        {/* Knowledge Base Card */}
                        <div className="flex items-center bg-white shadow-md rounded-xl p-5 gap-4">
                            <img
                                src="/faq1.webp"
                                alt="Book"
                                className="w-15 h-15 object-contain"
                            />
                            <div>
                                <h4 className="font-bold  text-lg leading-loose text-[#0A033C]">
                                    Knowledge Base &<br /> Documentation
                                </h4>
                            </div>
                        </div>

                        {/* Email Support Card */}
                        <div className="flex items-center bg-white shadow-md rounded-xl p-5 gap-4">
                            <img
                                src="/faq2.webp"
                                alt="Email"
                                className="w-15 h-15 object-contain"
                            />
                            <div>
                                <h4 className="font-bold text-lg text-[#0A033C]">Email Support</h4>
                                <p className="text-gray-500 text-sm">info@minterminds.com</p>
                            </div>
                        </div>

                    </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4">
                    {faqs.map((item, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-xl shadow-md transition-all`}
                        >
                            <button
                                onClick={() => handleToggle(index)}
                                className="w-full text-left px-6 py-4 flex justify-between items-center text-[#0A033C] font-medium"
                            >
                                <span className="text-sm">{item.question}</span>
                                <span className="text-lg">{openIndex === index ? "−" : "+"}</span>
                            </button>
                            {openIndex === index && (
                                <div className="px-6 pb-5 text-gray-500 text-sm">
                                    {item.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
